import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '../../../providers/amplify.service';

function ConfirmSignInComponentIonic_div_1_div_29_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵtext(3, "\n      ");
    ɵngcc0.ɵɵelementStart(4, "span", 13);
    ɵngcc0.ɵɵtext(5, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n      ");
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n      ");
    ɵngcc0.ɵɵelementStart(10, "a", 15);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentIonic_div_1_div_29_Template_a_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAlertClose(); });
    ɵngcc0.ɵɵtext(11, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, "\n  ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.amplifyService.i18n().get(ctx_r2.errorMessage));
} }
function ConfirmSignInComponentIonic_div_1_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtext(1, "\n  ");
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtext(3, "\n    ");
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n    ");
    ɵngcc0.ɵɵelementStart(7, "ion-list");
    ɵngcc0.ɵɵtext(8, "\n      ");
    ɵngcc0.ɵɵelementStart(9, "ion-item", 4);
    ɵngcc0.ɵɵtext(10, "\n        ");
    ɵngcc0.ɵɵelementStart(11, "ion-label", 5);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, "\n        ");
    ɵngcc0.ɵɵelementStart(14, "ion-input", 6, 7);
    ɵngcc0.ɵɵlistener("keyup", function ConfirmSignInComponentIonic_div_1_Template_ion_input_keyup_14_listener() { ɵngcc0.ɵɵrestoreView(_r6); var _r1 = ɵngcc0.ɵɵreference(15); var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setCode(_r1.value); })("keyup.enter", function ConfirmSignInComponentIonic_div_1_Template_ion_input_keyup_enter_14_listener() { ɵngcc0.ɵɵrestoreView(_r6); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onConfirm(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(16, "\n      ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, "\n\n    ");
    ɵngcc0.ɵɵelementStart(19, "div", 8);
    ɵngcc0.ɵɵtext(20, "\n      ");
    ɵngcc0.ɵɵelementStart(21, "div");
    ɵngcc0.ɵɵtext(22, "\n        ");
    ɵngcc0.ɵɵelementStart(23, "ion-button", 9);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentIonic_div_1_Template_ion_button_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r6); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onConfirm(); });
    ɵngcc0.ɵɵtext(24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(25, "\n      ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(26, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(27, "\n  ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(28, "\n\n  ");
    ɵngcc0.ɵɵtemplate(29, ConfirmSignInComponentIonic_div_1_div_29_Template, 14, 1, "div", 10);
    ɵngcc0.ɵɵtext(30, "\n\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1("\n        ", ctx_r0.amplifyService.i18n().get("Confirm your sign in code"), "\n    ");
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate1("\n          ", ctx_r0.amplifyService.i18n().get("Code *"), "\n        ");
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Confirm Code"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Inject } from '@angular/core';
import { AmplifyService } from '../../../providers/amplify.service';
import { ConfirmSignInComponentCore } from './confirm-sign-in-component.core';
import { auth } from '../../../assets/data-test-attributes';
var template = "\n<div class=\"amplify-form-container\" *ngIf=\"_show\" data-test=\"" + auth.confirmSignIn.section + "\">\n  <div class=\"amplify-form-body\" data-test=\"" + auth.confirmSignIn.bodySection + "\">\n    <div\n      class=\"amplify-form-header amplify-form-header-ionic\"\n      data-test=\"" + auth.confirmSignIn.headerSection + "\"\n      >\n        {{ this.amplifyService.i18n().get('Confirm your sign in code') }}\n    </div>\n    <ion-list>\n      <ion-item lines=\"none\">\n        <ion-label class=\"amplify-input-label amplify-input-label-ionic\" position=\"stacked\">\n          {{ this.amplifyService.i18n().get('Code *') }}\n        </ion-label>\n        <ion-input\n          #code\n          type=\"text\"\n          class=\"amplify-form-input\"\n          (keyup)=\"setCode(code.value)\"\n          (keyup.enter)=\"onConfirm()\"\n          data-test=\"" + auth.confirmSignIn.codeInput + "\"\n        ></ion-input>\n      </ion-item>\n    </ion-list>\n\n    <div class=\"amplify-form-actions\">\n      <div>\n        <ion-button expand=\"block\" color=\"primary\"\n          (click)=\"onConfirm()\"\n          data-test=\"" + auth.confirmSignIn.confirmButton + "\"\n        >{{ this.amplifyService.i18n().get('Confirm Code') }}</ion-button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"amplify-alert\" *ngIf=\"errorMessage\">\n    <div class=\"amplify-alert-body\">\n      <span class=\"amplify-alert-icon\">&#9888;</span>\n      <div class=\"amplify-alert-message\">{{ this.amplifyService.i18n().get(errorMessage) }}</div>\n      <a class=\"amplify-alert-close\" (click)=\"onAlertClose()\">&times;</a>\n    </div>\n  </div>\n\n</div>\n";
var ConfirmSignInComponentIonic = /** @class */ (function (_super) {
    __extends(ConfirmSignInComponentIonic, _super);
    function ConfirmSignInComponentIonic(amplifyService) {
        var _this = _super.call(this, amplifyService) || this;
        _this.amplifyService = amplifyService;
        return _this;
    }
    /** @nocollapse */
    ConfirmSignInComponentIonic.ctorParameters = function () { return [
        { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] },] },
    ]; };
ConfirmSignInComponentIonic.ɵfac = function ConfirmSignInComponentIonic_Factory(t) { return new (t || ConfirmSignInComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ConfirmSignInComponentIonic.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignInComponentIonic, selectors: [["amplify-auth-confirm-sign-in-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["class", "amplify-form-container", "data-test", "confirm-sign-in-section", 4, "ngIf"], ["data-test", "confirm-sign-in-section", 1, "amplify-form-container"], ["data-test", "confirm-sign-in-body-section", 1, "amplify-form-body"], ["data-test", "confirm-sign-in-header-section", 1, "amplify-form-header", "amplify-form-header-ionic"], ["lines", "none"], ["position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "text", "data-test", "confirm-sign-in-code-input", 1, "amplify-form-input", 3, "keyup", "keyup.enter"], ["code", ""], [1, "amplify-form-actions"], ["expand", "block", "color", "primary", "data-test", "confirm-sign-in-confirm-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ConfirmSignInComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n");
        ɵngcc0.ɵɵtemplate(1, ConfirmSignInComponentIonic_div_1_Template, 31, 4, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmSignInComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-in-ionic',
                template: template
            }]
    }], function () { return [{ type: ɵngcc2.AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
    return ConfirmSignInComponentIonic;
}(ConfirmSignInComponentCore));
export { ConfirmSignInComponentIonic };

